// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55a6bafa","453":"91e8a6f1","732":"8f12e027","977":"bfa2544c"}[chunkId] + ".chunk.js";
};